import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosConfig";


// Async Thunks
export const getRequestedProperties = createAsyncThunk(
  "agent/getRequestedProperties",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/agents/requestinterestlist/${id}`, data);
      console.log("Assigned properties",response)
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const getNearbyAgents = createAsyncThunk(
  "agent/getNearbyAgents",
  async ({ param1, param2, param3, param4,  }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/api/agents/nearbyagent/${param1},${param2}/${param4}`,param3);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const getMyAgents = createAsyncThunk(
  "agent/getMyAgents",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/agents/gethireagentbyuser/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);



export const getOrderdetailOfAgent = createAsyncThunk(
  "agent/getOrderdetailOfAgent",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/agents/getCallBack?order_id=${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);



export const getAgentLeadList = createAsyncThunk(
  "agent/getAgentLeadList",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/agents/getagentleadlist/${id}`, data);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getAgentBookedProperties = createAsyncThunk(
  "agent/getAgentBookedProperties",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/book/findbyagent/${id}`, data);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getPropertyVisitors = createAsyncThunk(
  "agent/getPropertyVisitors",
  async ({ userid, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/users/getvisitorlist/${userid}?page=${1}`, data);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getPropertyVisitorsRequests = createAsyncThunk(
  "agent/getPropertyVisitorsRequests",
  async ({ userid, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/users/getvisitorrequest/${userid}?page=${1}`, data);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getPromoteUsers = createAsyncThunk(
  "agent/getPromoteUsers",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/api/profilepremium/getUserPremiumList', data);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getAgentReviews = createAsyncThunk(
  "agent/getAgentReviews",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/users/getRatingAgentList/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  requestedProperties: [],
  nearbyAgents: [],
  promoteUsers: [],
  agentOrderDetails: {},
  AgentLeadList: [],
  AgentBookedProperties: [],
  PropertyVisitorsList: [],
  PropertyVisitorsRequestsList: [],
  myAgents: [],
  agentReviewList: [],
  status: "idle",
  error: null
};

const agentSlice = createSlice({
  name: "agent",
  initialState,
  reducers: {
    resetAgentState: (state) => {
      Object.assign(state, initialState);
    },
    clearAgentError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    const addCaseHandlers = (thunk, stateProperty) => {
      builder
        .addCase(thunk.pending, (state) => {
          state.status = "loading";
          state.error = null;
        })
        .addCase(thunk.fulfilled, (state, action) => {
          state.status = "succeeded";
          state[stateProperty] = action.payload;
        })
        .addCase(thunk.rejected, (state, action) => {
          state.status = "failed";
          state.error = action.payload || action.error.message;
        });
    };

    addCaseHandlers(getRequestedProperties, "requestedProperties");
    addCaseHandlers(getNearbyAgents, "nearbyAgents");
    addCaseHandlers(getPromoteUsers, "promoteUsers");
    addCaseHandlers(getMyAgents, "myAgents");
    addCaseHandlers(getAgentReviews, "agentReviewList");
    addCaseHandlers(getOrderdetailOfAgent, "agentOrderDetails");
    addCaseHandlers(getAgentLeadList, "AgentLeadList");
    addCaseHandlers(getAgentBookedProperties, "AgentBookedProperties");
    addCaseHandlers(getPropertyVisitors, "PropertyVisitorsList");
    addCaseHandlers(getPropertyVisitorsRequests, "PropertyVisitorsRequestsList");
  }
});

export const { resetAgentState, clearAgentError } = agentSlice.actions;
export default agentSlice.reducer;